import { useEffect, useState } from 'react';
import axios from 'axios';
import { useQuery } from 'react-query';
import { SearchHit, SearchResults } from '../models/searchHit';

const apiUrl = process.env.REACT_APP_BASIX_API || '';

const search = async (q: string): Promise<SearchHit[]> => {
  const { data } = await axios.get<SearchResults>(`${apiUrl}search`, { params: { q } });
  return data.index ?? [];
};

// debounce the raw input so we don't hit the endpoint on every keystroke
const useDebounced = (value: string, ms: number): string => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const h = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(h);
  }, [value, ms]);
  return debounced;
};

// item 107: entire-site search. Returns hits for a query (>= 2 chars), debounced.
const useGlobalSearch = (rawQuery: string) => {
  const q = useDebounced(rawQuery.trim(), 200);
  const enabled = q.length >= 2;

  const { data, status, isFetching } = useQuery(['globalSearch', q], () => search(q), {
    enabled,
    keepPreviousData: true,
  });

  return {
    query: q,
    hits: enabled ? data ?? [] : [],
    isLoading: enabled && (status === 'loading' || isFetching),
  };
};

export default useGlobalSearch;
